import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Globe } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const Header = () => {
  const { t, locale, setLocale, LOCALES } = useI18n();
  return (
    <header
      className="no-print w-full border-b border-[#E2E8F0] bg-white/80 backdrop-blur-sm sticky top-0 z-40"
      data-testid="app-header"
    >
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12 py-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-2 h-2 rounded-full bg-[#002D5B] shrink-0" aria-hidden="true" />
          <span className="font-display text-sm md:text-base font-medium tracking-tight text-[#0F172A] truncate">
            {t("header.title")}
          </span>
        </div>

        <div className="flex items-center gap-4 shrink-0">
          <div className="flex items-center gap-2" data-testid="language-switcher">
            <Globe
              className="w-4 h-4 text-[#64748B] hidden sm:block"
              strokeWidth={1.75}
              aria-hidden="true"
            />
            <Select value={locale} onValueChange={setLocale}>
              <SelectTrigger
                data-testid="select-language"
                aria-label={t("language.label")}
                className="h-9 w-[140px] border-[#E2E8F0] focus:ring-2 focus:ring-[#002D5B] focus:ring-offset-0 text-sm"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {LOCALES.map((l) => (
                  <SelectItem
                    key={l.code}
                    value={l.code}
                    data-testid={`language-option-${l.code}`}
                  >
                    {l.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <a
            href="https://www.helvar.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center shrink-0 transition-opacity hover:opacity-85"
            data-testid="brand-logo"
            aria-label="Helvar"
          >
            <img
              src="/helvar-logo.png"
              alt="Helvar"
              className="h-10 md:h-11 w-auto block"
            />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
